import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const EquipmentV2 = React.lazy(async () => ({
    default: (await import('@oc/equipment-v2/module')).EquipmentV2Module
}))

export function EquipmentV2Component() {
    return <SuspenseWhileLoading LazyComponent={EquipmentV2} />
}
